<template>
    <div>
        <legend>Названия прайсов партнера</legend>
        <dx-data-grid
                :show-borders="true"
                :data-source="dataSource"
                :remote-operations="true"
        >
            <dx-editing
                    :allow-updating="true"
                    :allow-deleting="true"
                    :allow-adding="true"
                    mode="row"
            />
            <dx-column
                    data-field="Name"
                    caption="Название"
            />
        </dx-data-grid>
    </div>
</template>
<script>
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { DxColumn, DxDataGrid, DxEditing } from 'devextreme-vue/data-grid';

const url = `${process.env.VUE_APP_API_HOST}admin/price-list`;


export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
    };
  },
  computed: {
    dataSource() {
      const token = this.$auth.token();
      return createStore({
        key: 'Id',
        loadUrl: `${url}/${this.$route.params.id}`,
        insertUrl: `${url}/${this.$route.params.id}/insert`,
        updateUrl: `${url}/update`,
        deleteUrl: `${url}/delete`,
        onBeforeSend(operation, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`,
          };
        },
      });
    },
  },
};
</script>
